import type { ElementType } from "react";
import { useTranslation } from "react-i18next";

interface HowToReadProps {
  className?: string;
  headingAs?: "h1" | "h2";
  onClose?: () => void;
  panelId?: string;
  titleId?: string;
}

export function HowToRead({
  className,
  headingAs = "h1",
  onClose = () => {},
  panelId = "how-to-read-panel",
  titleId = "how-to-read-title"
}: HowToReadProps) {
  const Heading = headingAs as ElementType;
  const { t } = useTranslation();
  const terms = ["wind", "thermal", "cloud", "character", "map"] as const;

  return (
    <section
      aria-labelledby={titleId}
      className={className ?? "how-to-read-panel"}
      id={panelId}
      role="region"
    >
      <div className="about-masthead">
        <div>
          <span className="about-label">{t("guide.title")}</span>
          <Heading id={titleId}>{t("guide.title")}</Heading>
        </div>
        <button
          aria-label={t("guide.closeA11y")}
          onClick={onClose}
          type="button"
        >
          {t("common.close")}
        </button>
      </div>

      <p>{t("guide.intro")}</p>

      <dl>
        {terms.map((term) => (
          <div key={term}>
            <dt>{t(`guide.${term}Term`)}</dt>
            <dd>{t(`guide.${term}Description`)}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
